module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/triangle-gray@3x-462c5b920ed7212dccc3d9cd0b040e2d.png";